import React, {Component} from "react"
import { Controller } from 'react-hook-form'
import UncontrolledInputGroupBuilder from './UncontrolledInputGroupBuilder'

class InputGroupBuilder extends Component {
	render() {
		const {name, type, control, defaultValue, ...rest} = this.props
    return (
			<Controller
				render={(renderProps) => {
					return (
						<UncontrolledInputGroupBuilder
							name={name}
							type={type}
							value={renderProps.value}
							onChange={(value) => {
								renderProps.onChange(value)
							}}
							{...rest}
						/>
					)
				}}
				control={control}
				name={name}
				defaultValue={defaultValue}
			/>
    )
	}
}

export default InputGroupBuilder